<script lang="ts">
  import { onMount } from "svelte";
  import SearchHeader from "../../components/SearchHeader.svelte";
  import { Table } from "../../components/Table";
  import MainLayout from "../../layout/MainLayout.svelte";
  import { filter, loading, records, pagination, initList, onCreate, onEdit, onDelete, onPageChange, search } from "./recipe.store";
  import { recipeDtoFields } from "../../utils/TableFields/recipe-dto.fields";

  onMount(initList);
</script>

<MainLayout>
  <SearchHeader
    entitySingular="ricetta"
    entityPlural="ricette"
    numRecords={$pagination != null ? $pagination.totalRecords : 0}
    bind:searchValue={$filter.criteria.query}
    on:search={search}
  ></SearchHeader>

  <Table
    loading={$loading}
    fields={recipeDtoFields}
    records={$records}
    pagination={$pagination}
    createEnabled={true}
    editEnabled={true}
    deleteEnabled={true}
    on:create={(_) => onCreate()}
    on:edit={(e) => onEdit(e.detail)}
    on:delete={(e) => onDelete(e.detail)}
    on:pageChange={(e) => onPageChange(e.detail)}
  />
</MainLayout>
